import notificationTypes from './notificationTypes';

const INITIAL_STATE = {
  items: [],
  unreadCount: 0,
  unseenCount: 0,
  fetching: false,
  error: null,
  cursor: null,
  hasMore: true,
};

const dedupeNotifications = (existing, incoming = []) => {
  const existingIds = new Set(existing.map((n) => n.notificationId));
  const deduped = incoming.filter((n) => !existingIds.has(n.notificationId));
  return [...existing, ...deduped];
};

const notificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case notificationTypes.ADD_NOTIFICATION: {
      const existing = state.items.filter(
        (n) => n.notificationId !== action.payload.notificationId
      );
      return {
        ...state,
        items: [action.payload, ...existing],
        unreadCount: state.unreadCount + (action.payload.isRead ? 0 : 1),
        unseenCount: state.unseenCount + (action.payload.isSeen ? 0 : 1),
      };
    }
    case notificationTypes.FETCH_NOTIFICATIONS_START: {
      return {
        ...state,
        fetching: true,
        error: null,
        ...(action.meta?.append
          ? {}
          : {
              items: [],
              cursor: null,
              hasMore: true,
            }),
      };
    }
    case notificationTypes.FETCH_NOTIFICATIONS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    }
    case notificationTypes.FETCH_NOTIFICATIONS_SUCCESS: {
      const { items, nextCursor, unreadCount, unseenCount, append } =
        action.payload;
      const merged = append
        ? dedupeNotifications(state.items, items)
        : items || [];
      return {
        ...state,
        fetching: false,
        error: null,
        items: merged,
        cursor: nextCursor || null,
        hasMore: Boolean(nextCursor),
        unreadCount: typeof unreadCount === 'number' ? unreadCount : state.unreadCount,
        unseenCount: typeof unseenCount === 'number' ? unseenCount : state.unseenCount,
      };
    }
    case notificationTypes.MARK_NOTIFICATION_AS_READ: {
      let decremented = false;
      const items = state.items.map((notification) => {
        if (notification.notificationId === action.payload) {
          if (!notification.isRead) {
            decremented = true;
          }
          return {
            ...notification,
            isRead: true,
            readAt: new Date().toISOString(),
          };
        }
        return notification;
      });
      return {
        ...state,
        items,
        unreadCount: decremented
          ? Math.max(0, state.unreadCount - 1)
          : state.unreadCount,
      };
    }
    case notificationTypes.MARK_NOTIFICATIONS_SEEN: {
      const items = state.items.map((notification) =>
        notification.isSeen
          ? notification
          : { ...notification, isSeen: true, seenAt: new Date().toISOString() }
      );
      return {
        ...state,
        items,
        unseenCount: 0,
      };
    }
    case notificationTypes.UPDATE_NOTIFICATION_COUNTS: {
      return {
        ...state,
        unreadCount:
          typeof action.payload?.unreadCount === 'number'
            ? action.payload.unreadCount
            : state.unreadCount,
        unseenCount:
          typeof action.payload?.unseenCount === 'number'
            ? action.payload.unseenCount
            : state.unseenCount,
      };
    }
    case notificationTypes.CLEAR_NOTIFICATIONS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};

export default notificationReducer;
